import { __awaiter, __generator } from "tslib";
var VELT_SDK_VERSION = '5.0.2-beta.4';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
var INTEGRITY_MAP = {
    '5.0.2-beta.4': 'sha384-+43/FRK/cLNnNVE4RecynwhDmvj43/XHhGNI46A7fmJF7IPgJZ8kztGM1Q7HTTej',
};
var loadVelt = function (options) {
    return new Promise(function (resolve, reject) {
        var existingScript = document.getElementById('veltScript');
        var staging = false;
        var develop = false;
        var version = 'latest';
        var proxyDomain = '';
        var integrity = false;
        var integrityValue = '';
        if (options) {
            if (options.staging) {
                staging = options.staging;
            }
            if (options.version) {
                version = options.version;
            }
            if (options.develop) {
                develop = options.develop;
            }
            if (options.proxyDomain) {
                proxyDomain = options.proxyDomain;
            }
            if (options.integrity) {
                integrity = options.integrity;
            }
        }
        if (!(options === null || options === void 0 ? void 0 : options.version)) {
            version = VELT_SDK_VERSION;
        }
        if (integrity) {
            // if develop or staging, use the integrity from the options
            // otherwise, use the integrity from the INTEGRITY_MAP
            if (develop || staging) {
                if (options === null || options === void 0 ? void 0 : options.sriv) {
                    integrityValue = options.sriv;
                }
            }
            else {
                if (INTEGRITY_MAP[version]) {
                    integrityValue = INTEGRITY_MAP[version];
                }
            }
        }
        if (!existingScript) {
            var script = document.createElement('script');
            if (staging) {
                script.src = "https://us-central1-snipply-sdk-staging.cloudfunctions.net/getprivatenpmpackagefile?packageName=sdk-staging&packageVersion=".concat((!version || version === 'latest') ? '1.0.1' : version, "&filePath=velt.js&orgName=@veltdev");
            }
            else if (develop) {
                script.src = "https://us-central1-snipply-sdk-staging.cloudfunctions.net/getprivatenpmpackagefile?packageName=sdk-dev&packageVersion=".concat((!version || version === 'latest') ? '1.0.1' : version, "&filePath=velt.js&orgName=@veltdev");
            }
            else {
                if (proxyDomain) {
                    // remove trailing slash from proxy
                    if (proxyDomain[proxyDomain.length - 1] === '/') {
                        proxyDomain = proxyDomain.slice(0, -1);
                    }
                    script.src = "".concat(proxyDomain, "/lib/sdk@").concat(version, "/velt.js");
                }
                else {
                    script.src = "https://cdn.velt.dev/lib/sdk@".concat(version, "/velt.js");
                }
            }
            script.id = 'veltScript';
            script.type = 'module';
            // if integrity is set, add it to the script tag and set crossOrigin to anonymous
            if (integrity && integrityValue) {
                script.integrity = integrityValue;
                script.crossOrigin = 'anonymous';
            }
            document.body.appendChild(script);
            script.onload = function () {
                // Resolve the promise when the script has loaded
                resolve();
            };
            script.onerror = function () {
                // Reject the promise if there is an error loading the script
                reject(new Error('Failed to load Velt script'));
            };
        }
        else {
            // Resolve the promise immediately if the script already exists
            resolve();
        }
    });
};
export var initVelt = function (apiKey, config) { return __awaiter(void 0, void 0, void 0, function () {
    var options, velt, err_1;
    var _a, _b, _c, _d, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                _g.trys.push([0, 6, , 7]);
                options = {};
                // if config is an object, use the options from the config to make it backwards compatible
                // otherwise, use the options from the config object
                options.staging = ((_a = config === null || config === void 0 ? void 0 : config.options) === null || _a === void 0 ? void 0 : _a.staging) || (config === null || config === void 0 ? void 0 : config.staging);
                options.version = ((_b = config === null || config === void 0 ? void 0 : config.options) === null || _b === void 0 ? void 0 : _b.version) || (config === null || config === void 0 ? void 0 : config.version);
                options.develop = ((_c = config === null || config === void 0 ? void 0 : config.options) === null || _c === void 0 ? void 0 : _c.develop) || (config === null || config === void 0 ? void 0 : config.develop);
                options.proxyDomain = ((_d = config === null || config === void 0 ? void 0 : config.options) === null || _d === void 0 ? void 0 : _d.proxyDomain) || (config === null || config === void 0 ? void 0 : config.proxyDomain);
                options.integrity = ((_e = config === null || config === void 0 ? void 0 : config.options) === null || _e === void 0 ? void 0 : _e.integrity) || (config === null || config === void 0 ? void 0 : config.integrity);
                options.sriv = ((_f = config === null || config === void 0 ? void 0 : config.options) === null || _f === void 0 ? void 0 : _f.sriv) || (config === null || config === void 0 ? void 0 : config.sriv);
                return [4 /*yield*/, loadVelt(options)];
            case 1:
                _g.sent();
                velt = window.Velt;
                if (!config) return [3 /*break*/, 3];
                return [4 /*yield*/, (velt === null || velt === void 0 ? void 0 : velt.init(apiKey, config))];
            case 2:
                _g.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, (velt === null || velt === void 0 ? void 0 : velt.init(apiKey))];
            case 4:
                _g.sent();
                _g.label = 5;
            case 5:
                if (velt === null || velt === void 0 ? void 0 : velt.st) {
                    velt === null || velt === void 0 ? void 0 : velt.st('client');
                }
                return [2 /*return*/, velt];
            case 6:
                err_1 = _g.sent();
                console.error(err_1);
                return [2 /*return*/, null];
            case 7: return [2 /*return*/];
        }
    });
}); };
export var getVeltClient = function () { return __awaiter(void 0, void 0, void 0, function () {
    var err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                if (!!window.Velt) return [3 /*break*/, 2];
                return [4 /*yield*/, loadVelt()];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/, window.Velt];
            case 3:
                err_2 = _a.sent();
                console.error(err_2);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
